//init tesxts state with default strings
const state = () => ({
    hasHealthConsent: false,
});

const mutations = {
    setCorporate(state: any, payload: any) {
        state.hasHealthConsent = payload.hasHealthConsent;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};
